import { useMemo } from 'react';
import { createAppDefaults } from '@eventbrite/bsp-sdk';
import type { BspSdkConfig, BspEnvironment } from '@eventbrite/bsp-sdk';
import { Stage } from '@eventbrite/webapp-constants';

// covid-19 has no experiment/remote-settings needs today; an empty settings
// object keeps useBspConfig() the same shape other apps use (creator-onboarding-
// webapp's common/bsp/config.ts) without inventing unused flags.
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export type Covid19Settings = {};

const DEFAULT_SETTINGS = createAppDefaults<Covid19Settings>({});

// Map the CDK-injected Stage (Local/Dev/Test/Prod — see cdk/bin/cdk.ts) to
// bsp-sdk's BspEnvironment. This is deliberately NOT hostname-sniffing:
// creator-onboarding-webapp's own reference config.ts derives environment
// from `window.location.hostname` (only special-casing 'evbqa'/'localhost'),
// which silently mislabels Eventbrite DEV (served on evbdev) and any
// evbstage host as 'production' — Bugbot PR #89 caught this class of bug
// here. STAGE is server-injected and authoritative, so use it instead of
// re-deriving environment from a client-side domain string.
const environmentForStage = (stage: Stage): BspEnvironment => {
    switch (stage) {
        case Stage.PROD:
            return 'production';
        case Stage.TEST:
            return 'staging';
        case Stage.DEV:
        case Stage.LOCAL:
        default:
            return 'development';
    }
};

export const useBspConfig = (stage: Stage): BspSdkConfig<Covid19Settings> =>
    useMemo(
        () => ({
            appName: 'covid-19-webapp',
            environment: environmentForStage(stage),
            defaultOrionSettings: DEFAULT_SETTINGS,
            defaultSegmentations: {},
        }),
        [stage],
    );
